import React, { useState } from 'react'
import { Card, Button } from 'react-bootstrap'
import PaymentDetailFill from './updatePlanModal/PaymentDetailFill'
import { usePlan } from '../../../context/PlanContext'
import ReactModal from 'react-modal'

type Props = {
  plan: any
  selectedCurrency: any
}

const CardSubscription: React.FC<Props> = ({ plan, selectedCurrency }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState<boolean>(false)
  const { currentPlan } = usePlan()

  const customModalStyles: any = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  }

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true)
  }

  const afterOpenPaymentModal = () => {
    // Do something after modal opens if needed
  }

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false)
  }

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const styleHover = {
    transform: `scale(${isHovered ? '1.025' : '1'})`,
    transition: 'transform 0.2s ease-in-out',
    boxShadow: isHovered ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'
  }

  // Convert price to the selected currency
  const convertedPrice = plan.package.packageAmount

  // Determine currency symbol
  const currencySymbol = selectedCurrency === 'USD' ? '$' : '₹'

  // Check if the plan is already subscribed
  const isSubscribed = currentPlan.packageFeatureId === plan.packageFeatureId

  return (
    <>
      <Card
        className='bg-white p-10 rounded-lg shadow subscription-card '
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={styleHover}
      >
        <h1 className='h6 text-uppercase font-weight-bold mb-4'>{plan.title}</h1>
        <h2 className='h1 font-weight-bold'>
          {currencySymbol}
          {convertedPrice}
          <span className='text-small font-weight-normal ml-2'>{` /Month`}</span>
        </h2>
        <div className='custom-separator my-4 mx-auto bg-primary'></div>
        <div className='mt-4 mb-6'>{plan?.package?.packageDescriptions}</div>
        {/* <ul className='list-unstyled my-5 text-small text-left'>
          {Object.keys(plan.features)
            .slice(0, 15)
            .map((key, index) => (
              <li key={index} className='mb-3'>
                {`${formatFeatureKey(key)}: ${plan.features[key] === true || plan.features[key] === false
                    ? ''
                    : plan.features[key]
                  }`}
                <i
                  className={`fa mr-2 ${plan.features[key] === true
                      ? 'fa-check text-primary'
                      : plan.features[key] === false
                        ? 'fa-times text-danger'
                        : ''
                    }`}
                ></i>
              </li>
            ))}
        </ul> */}
        {/* Render different content based on subscription status */}
        {isSubscribed ? (
          <Button className='btn btn-success p-3 shadow rounded-pill w-50 mx-auto' disabled>
            Subscribed
          </Button>
        ) : (
          <Button
            className='btn btn-primary p-3 shadow rounded-pill w-50 mx-auto'
            onClick={openPaymentModal}
          >
            Subscribe
          </Button>
        )}
      </Card>

      <ReactModal
        isOpen={isPaymentModalOpen}
        onAfterOpen={afterOpenPaymentModal}
        onRequestClose={closePaymentModal}
        style={customModalStyles}
        contentLabel='Payment Fill'
      >
        <PaymentDetailFill
          closePaymentModal={closePaymentModal}
          plan={plan}
          currentPlan={currentPlan}
        />
      </ReactModal>
    </>
  )
}

export default CardSubscription
